import { Routes } from '@angular/router';

import { authGuard } from '@app/core/guards/auth.guard';
import { locationSetGuard } from '@app/core/guards/location-set.guard';

import { RequirePermission } from '@app/core/enums/require-permission.enum';
import { LoginComponent } from '@app/modules/login/login.component';
import { LocationPickerComponent } from '@app/modules/location/pages/location-picker/location-picker.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        component: LoginComponent
    },
    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Login' }
    },
    {
        path: 'location-picker',
        component: LocationPickerComponent,
        canActivate: [authGuard],
        data: { title: 'Choose a location' }
    },
    {
        path: 'inspections',
        loadChildren: () => import('./modules/inspection/pages/inspection-list/inspection-list.routes').then(m => m.inspectionListRoutes),
        canActivate: [authGuard, locationSetGuard],
        data: { title: 'Inspections' }
    },
    {
        path: 'inspection',
        loadChildren: () => import('./modules/inspection/pages/inspection-detail/inspection-detail.routes').then(m => m.inspectionDetailRoutes),
        canActivate: [authGuard, locationSetGuard],
        data: { title: 'Inspection Detail' }
    },
    {
        path: 'tenants',
        loadChildren: () => import('./modules/tenant/tenant.routes').then(m => m.tenantRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetTenant] }
    },
    {
        path: 'tenant-admin',
        loadChildren: () => import('./modules/tenant/pages/tenant-admin/tenant-admin.routes').then(m => m.tenantAdminRoutes),
        canActivate: [authGuard],
        data: {
            title: 'Tenant Admin',
            permissions: [RequirePermission.GetTenantStyle]
        }
    },
    {
        path: 'inspection-type-groups',
        loadChildren: () => import('./modules/inspection-type-group/inspection-type-group.routes').then(m => m.inspectionTypeGroupRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetInspectionTypeGroup] }
    },
    {
        path: 'inspection-types',
        loadChildren: () => import('./modules/inspection-type/inspection-type.routes').then(m => m.inspectionTypeRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetInspectionType] }
    },
    {
        path: 'category-types',
        loadChildren: () => import('./modules/category-type/category-type.routes').then(m => m.categoryTypeRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetCategoryType] }
    },
    {
        path: 'groups',
        loadChildren: () => import('./modules/group/group.routes').then(m => m.groupRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetGroup] }
    },
    {
        path: 'roles',
        loadChildren: () => import('./modules/role/role.routes').then(m => m.roleRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetRole] }
    },
    {
        path: 'locations',
        loadChildren: () => import('./modules/location/location.routes').then(m => m.locationRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetLocation] }
    },
    {
        path: 'operation-support',
        loadChildren: () => import('./modules/operation-support/operation-support.routes').then(m => m.operationSupportRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetOperationalSupport] }
    },
    {
        path: 'picklist-editor',
        loadChildren: () => import('./modules/picklist-editor/picklist-editor.routes').then(m => m.picklistEditorRoutes),
        canActivate: [authGuard],
        data: { permissions: [RequirePermission.GetOperationalSupport] }
    },
    {
        path: '**',
        redirectTo: 'location-picker'
    }
];
